import { Model } from 'pinia-orm';
import { Attr, BelongsTo, MorphMany, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import Comment from './Comment';
import PackageTradeItem from './PackageTradeItem';
import TradeItem from './TradeItem';
/* --- user header --- */
/* --- end user header --- */

export default class RatesCost extends Model {
  static entity = 'App\\Models\\RatesCost';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare claim_id: number;
  @Num(0)
  declare package_trade_item_id: number;
  @Num(0)
  declare trade_item_id: number;
  @Num(undefined)
  declare current_quantity: number | undefined;
  @Num(undefined)
  declare current_certified: number | undefined;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;
  @BelongsTo(() => PackageTradeItem, 'package_trade_item_id', 'id')
  declare package_trade_item: PackageTradeItem;
  @BelongsTo(() => TradeItem, 'trade_item_id', 'id')
  declare trade_item: TradeItem;
  @MorphMany(() => Comment, 'commentable_id', 'commentable_type', 'id')
  declare comments: Comment[];
  /* --- user code --- */

  @Attr(undefined)
  declare $summaryClaim: number | undefined;
  @Attr(undefined)
  declare $summaryCertified: number | undefined;

  /* --- end user code --- */
}
